export default import.meta.ROLLDOWN_FILE_URL_hk0eWL8cxGBeGXVsYM8rQw